/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalApplicationLogoService {

    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static getCoreApiInternalApplicationLogosFile(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/internal-application-logos/file/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static getCoreApiInternalApplicationLogosFileUncached(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/internal-application-logos/file/{id}/uncached',
            path: {
                'id': id,
            },
        });
    }

}
